export const categories = [
  {
    id: "all",
    name: "全部话题",
    icon: "ri-fire-line",
    count: 1284,
    desc: "全网正在升温的讨论，一屏看全。",
  },
  {
    id: "entertainment",
    name: "娱乐八卦",
    icon: "ri-star-smile-line",
    count: 386,
    desc: "舞台、作品与人气动向的集中讨论。",
  },
  {
    id: "screen",
    name: "影视综",
    icon: "ri-film-line",
    count: 274,
    desc: "剧集、电影与综艺的追更与口碑现场。",
  },
  {
    id: "society",
    name: "社会热点",
    icon: "ri-earth-line",
    count: 231,
    desc: "公共议题与正在被广泛关注的事件。",
  },
  {
    id: "tech",
    name: "科技新鲜事",
    icon: "ri-cpu-line",
    count: 168,
    desc: "新品、趋势与数字生活的新鲜讨论。",
  },
  {
    id: "lifestyle",
    name: "生活方式",
    icon: "ri-leaf-line",
    count: 225,
    desc: "吃喝玩乐与日常审美的话题集合。",
  },
];